(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moc-codex-list"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const filterOptions = document.querySelectorAll('.filter-options h3');
  const codexItems = document.querySelectorAll('.codex-single');
  const artistSection = document.querySelector('.artist');

  filterOptions.forEach(option => {
    option.addEventListener('click', function () {
      const filter = this.getAttribute('data-id');

      // Remove active class from all options
      filterOptions.forEach(opt => opt.classList.remove('active'));
      this.classList.add('active');

      // Show/hide artist section based on filter
      if (artistSection) {
        if (filter === 'all') {
          artistSection.style.display = 'block';
        } else {
          artistSection.style.display = 'none';
        }
      }

      // Show/hide codex items based on filter
      codexItems.forEach(item => {
        if (filter === 'all' || item.getAttribute('data-card-type') === filter) {
          item.style.display = 'block';
        } else {
          item.style.display = 'none';
        }
      });

      // Reinitialize AOS after elements are shown/hidden
      AOS.refresh();
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moc-expansion-sets"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function() {
      if (window.Swiper) {
        new Swiper('.expansion-sets .swiper-container', {
          slidesPerView: 1,
          spaceBetween: 20,
          loop: false,
          autoHeight: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          breakpoints: {
            800: {
              slidesPerView: 2
            },
            1200: {
              slidesPerView: 3
            }
          }
        });
      }
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moc-product-hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const videos = document.querySelectorAll('.product-hero video');
    let video = Array.from(videos).find(v => getComputedStyle(v).display !== 'none');

    const playPause = document.querySelector('.play-pause');
    const progress = document.querySelector('.progress');
    const playIcon = playPause.querySelector('.play');
    const pauseIcon = playPause.querySelector('.pause');
    const audioButton = document.querySelector('.audio');
    const audioIcon = audioButton.querySelector('.audio');
    const muteIcon = audioButton.querySelector('.mute');

    function setInitialState() {
      playIcon.classList.remove('active');
      pauseIcon.classList.add('active');
      muteIcon.classList.add('active');
      audioIcon.classList.remove('active');
    }

    function bindEvents() {
      if (!video) return;

      video.addEventListener('ended', function() {
        playIcon.classList.add('active');
        pauseIcon.classList.remove('active');
      });

      video.addEventListener('timeupdate', function() {
        const value = (video.currentTime / video.duration) * 100;
        progress.style.width = value + '%';
      });
    }

    setInitialState();
    bindEvents();

    playPause.addEventListener('click', function() {
      if (!video) return;

      if (video.paused) {
        video.play();
        playIcon.classList.remove('active');
        pauseIcon.classList.add('active');
      } else {
        video.pause();
        playIcon.classList.add('active');
        pauseIcon.classList.remove('active');
      }
    });

    audioButton.addEventListener('click', function() {
      if (!video) return;

      if (video.muted) {
        video.muted = false;
        muteIcon.classList.remove('active');
        audioIcon.classList.add('active');
      } else {
        video.muted = true;
        muteIcon.classList.add('active');
        audioIcon.classList.remove('active');
      }
    });

    // Update video reference on resize
    window.addEventListener('resize', () => {
      const newVideo = Array.from(videos).find(v => getComputedStyle(v).display !== 'none');
      if (newVideo !== video) {
        video = newVideo;
        setInitialState();
        bindEvents();
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
